/**
 * Source images are heavier than what is displayed. This proxy (wsrv.nl,
 * free, CDN-backed) resizes them to the exact width, serves compressed WebP
 * and caches them long-term.
 */
const PROXY = 'https://wsrv.nl/'

export function optimizedImage(url: string, width: number, quality = 72): string {
  const params = new URLSearchParams({
    url,
    w: String(width),
    output: 'webp',
    q: String(quality),
  })
  return `${PROXY}?${params.toString()}`
}

export function optimizedSrcSet(
  url: string,
  widths: number[],
  quality?: number,
): string {
  return widths
    .map((width) => `${optimizedImage(url, width, quality)} ${width}w`)
    .join(', ')
}

/** Hero mockup: available widths and rendered width per breakpoint. */
export const HERO_WIDTHS = [480, 720, 960, 1240]
/** Full width on mobile (max 448px), up to 576px on tablet and desktop. */
export const HERO_SIZES = '(min-width: 640px) 576px, min(calc(100vw - 48px), 448px)'
/** Fallback src width and compression for the LCP image. */
export const HERO_SRC_WIDTH = 720
export const HERO_QUALITY = 62
